var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("v-modal-contents", {
        ref: "modal_contents_agree",
        scopedSlots: _vm._u([
          {
            key: "close",
            fn: function () {
              return [_c("div")]
            },
            proxy: true,
          },
          {
            key: "title",
            fn: function () {
              return [
                _c("div", { staticClass: "terms_of_use__title mt-30 pl-3 " }, [
                  _c("div", { staticClass: "h2_title" }, [
                    _vm._v("Условия использования персональных данных"),
                  ]),
                ]),
              ]
            },
            proxy: true,
          },
          {
            key: "content",
            fn: function () {
              return [
                _c("div", { staticClass: "terms_of_use mt-30 " }, [
                  _c("div", { domProps: { innerHTML: _vm._s(_vm.terms) } }),
                  _vm._v(" "),
                  _c("div", { staticClass: "mt-30" }, [
                    _c(
                      "button",
                      {
                        staticClass: "px-30 btn_bordered ",
                        on: {
                          click: function ($event) {
                            return _vm.$refs.modal_contents_agree.modal_open()
                          },
                        },
                      },
                      [_vm._v("\n            Прочитал\n          ")]
                    ),
                  ]),
                ]),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _vm._v(" "),
      _c(
        "v-form",
        {
          ref: "form",
          staticClass: "form_upload",
          attrs: { "lazy-validation": "" },
          model: {
            value: _vm.valid,
            callback: function ($$v) {
              _vm.valid = $$v
            },
            expression: "valid",
          },
        },
        [
          _c("div", [
            _c("div", { staticClass: "item" }, [
              _c(
                "div",
                { staticClass: "form_upload__item" },
                [
                  _c("v-text-field", {
                    attrs: {
                      rules: _vm.s_nameRules,
                      required: "",
                      solo: "",
                      id: "s_name",
                      placeholder: "Фамилия *",
                    },
                    model: {
                      value: _vm.s_name,
                      callback: function ($$v) {
                        _vm.s_name = $$v
                      },
                      expression: "s_name",
                    },
                  }),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "item" }, [
              _c(
                "div",
                { staticClass: "form_upload__item" },
                [
                  _c("v-text-field", {
                    attrs: {
                      rules: _vm.nameRules,
                      required: "",
                      solo: "",
                      id: "name",
                      placeholder: "Имя *",
                    },
                    model: {
                      value: _vm.name,
                      callback: function ($$v) {
                        _vm.name = $$v
                      },
                      expression: "name",
                    },
                  }),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "item" }, [
              _c(
                "div",
                { staticClass: "form_upload__item" },
                [
                  _c("v-text-field", {
                    attrs: {
                      required: "",
                      solo: "",
                      id: "patronymic",
                      placeholder: "Отчество",
                    },
                    model: {
                      value: _vm.patronymic,
                      callback: function ($$v) {
                        _vm.patronymic = $$v
                      },
                      expression: "patronymic",
                    },
                  }),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "item" }, [
              _c(
                "div",
                { staticClass: "form_upload__item" },
                [
                  _c("v-text-field", {
                    attrs: {
                      required: "",
                      solo: "",
                      id: "company",
                      placeholder: "Компания",
                    },
                    model: {
                      value: _vm.company,
                      callback: function ($$v) {
                        _vm.company = $$v
                      },
                      expression: "company",
                    },
                  }),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "item" }, [
              _c(
                "div",
                { staticClass: "form_upload__item" },
                [
                  _c("v-text-field", {
                    attrs: {
                      rules: _vm.emailRules,
                      required: "",
                      solo: "",
                      id: "email",
                      placeholder: "E-mail *",
                    },
                    model: {
                      value: _vm.email,
                      callback: function ($$v) {
                        _vm.email = $$v
                      },
                      expression: "email",
                    },
                  }),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "item" }, [
              _c(
                "div",
                {
                  staticClass:
                    "form_upload__item d-flex align-items-center justify-content-between mt-5 mb-35",
                },
                [
                  _c(
                    "div",
                    { staticClass: "btn_form" },
                    [
                      _c(
                        "v-btn",
                        {
                          staticClass: "px-30 btn_red",
                          attrs: { disabled: !_vm.valid },
                          on: { click: _vm.sendForm },
                        },
                        [_c("span", [_vm._v("Отправить")])]
                      ),
                    ],
                    1
                  ),
                ]
              ),
            ]),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }